import React from 'react';
import Header from '../components/header';
import Panels from '../containers/panels';
import Fullscreen from '../containers/fullscreen';

const App = () => {
	return (
		<div>
			<Header />
			<Panels />
			<Fullscreen />
		</div>
	);
};

export default App;



// WEBPACK FOOTER //
// ./src/components/app.js